import { supabase } from './supabase';

const RATE_LIMIT_SECONDS = 60;

export async function checkRateLimit(userId: string) {
  const now = new Date();
  const cutoff = new Date(now.getTime() - RATE_LIMIT_SECONDS * 1000);

  // Get the latest request
  const { data: latestRequest } = await supabase
    .from('repository_analyses')
    .select('created_at')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .limit(1)
    .single();

  if (!latestRequest) {
    return { canProceed: true, timeLeft: 0 };
  }

  const lastRequestTime = new Date(latestRequest.created_at);
  const timeSinceLastRequest = now.getTime() - lastRequestTime.getTime();
  const timeLeft = RATE_LIMIT_SECONDS - Math.floor(timeSinceLastRequest / 1000);

  return {
    canProceed: lastRequestTime < cutoff,
    timeLeft: Math.max(0, timeLeft)
  };
}